// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

/**
 * Shared model default authority for the frontend.
 *
 * Provider-specific defaults live in the provider catalog (YAML / fallback),
 * but the *system-wide floor* for fields like temperature and max_tokens
 * MUST be defined in exactly one place so that stores, migration utilities,
 * and UI components agree on the same fallback without scattered `0.2` /
 * `1024` literals.
 *
 * Consumers that need a per-provider override should still read from the
 * provider catalog first and only fall back to these constants when the
 * catalog entry is missing.
 */

/** System-wide default temperature for model inference. */
export const DEFAULT_TEMPERATURE = 0.2;

/** System-wide default max_tokens for model inference. */
export const DEFAULT_MAX_TOKENS = 1024;
